module.exports = __webpack_public_path__ + "static/media/Tennis Player.c7a31f9b.jpg";